module.exports = __webpack_public_path__ + "static/media/logoVision1.9846a97f.png";